//libs
import { styled } from '@nykaa/ui-components';

// constants
import { BASE_GUTTER_SPACE, BASE_BORDER_RADIUS, COLORS } from 'shared/styles/base';

export const HeaderContainer = styled.div`
  width: 100%;
  height: 56px;
  background-color: #fff;
  border-radius: ${2 * BASE_BORDER_RADIUS}px ${2 * BASE_BORDER_RADIUS}px 0 0;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
`;

export const CloseIcon = styled.i`
  margin: ${2 * BASE_GUTTER_SPACE}px 0 ${2 * BASE_GUTTER_SPACE}px ${2.5 * BASE_GUTTER_SPACE}px;
  font-size: 24px;
  color: ${COLORS.BLACK_92};
`;
